import LazyLoad from "vanilla-lazyload";

const Common = {
  lazyLoadInstance: null,

  init() {
    this.lazyLoadInstance = new LazyLoad();

    Common.events();
    Common.tabs();
  },

  events() {
    // SEO
    $(".seo-read-more").on("click", function (e) {
      $(this).parent().find(".content-hidden").toggleClass("show");
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Video.
    $(".js-play-video").on("click", function () {
      $(this).closest(".video").addClass("playing").find("video")[0].play();
    });

    $(".video__overlay").on("click", function () {
      $(this).parent().toggleClass("playing").find("video")[0].pause();
    });

    // Accordion
    $(".accordion").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    //Accordion mobile menu
    $(".accordion-mob").on("click", function () {
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active").next().slideUp();
      } else {
        $(".accordion-mob").parent().removeClass("active").next().slideUp();
        $(this).parent().addClass("active").next().slideDown().scrollTop();
        // let openablePanel = $(this).parent().next();

        // openablePanel.slideDown().scrollTop();

      }
    });

    // SEO
    $(".seo__more-btn").on("click", function () {
      let content = document.getElementsByClassName("seo__content-2")[0];
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      let text = $(this).children()[0].innerText;

      if (text == "LASĪT VAIRĀK") {
        $(this).children("span").text("Lasīt mazāk");
      } else {
        $(this).children("span").text("Lasīt vairāk");
      }

      $(this).toggleClass("active");
    });

    $(".scroll-to").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const target = btnEl.data("target");

      let offset;

      if ("top" == target) {
        offset = 0;
      } else {
        offset = $(target).offset().top - 200;
      }
      $("html,body").animate({
        scrollTop: offset,
      });
    });
  },

  /**
   * Tabs
   */
  tabs() {
    // Show first
    $("[data-tabs] [data-container]").not(":first-child").hide();
    $("[data-tabs] [data-target]").first().addClass("active");

    $("[data-target]").on("click", function () {
      const btnEl = $(this);
      const tabEl = btnEl.closest("[data-tabs]");

      const targetTab = btnEl.data("target");

      btnEl.parent().siblings().children().removeClass("active");
      btnEl.addClass("active");

      tabEl.find("[data-container]").hide();
      tabEl.find(`[data-container="${targetTab}"]`).show();
    });

    $('[data-target="1"]').addClass("active");
  },
};

export default Common;
